import Screen from '../../../../shared/utils/screen';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Colors from '../../../../shared/assets/style/default/color';
import styled from 'styled-components';

const ChannelListEventInfoContainer = styled.div<{
  extraInfo?: boolean;
}>`
  align-items: center;
  color: ${Colors['text']};
  display: flex;
  font-family: ${Fonts['light']};
  font-size: ${32 * Screen.widthRatio}px;
  line-height: ${(props) => (props.extraInfo ? 72 : 50 * Screen.widthRatio)}px;
  white-space: break-spaces;
`;

export default ChannelListEventInfoContainer;
